import { createTheme } from '@material-ui/core/styles';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { Theme } from '../theme';

import 'moment/locale/en-gb';
import 'moment/locale/es-mx';
import 'moment/locale/pt';

const localeMap = {
  en: 'en-gb',
  es: 'es-mx',
  pt: 'pt'
};

const commonPickerOverrides = {
  MuiPickersCalendarHeader: {
    iconButton: {
      padding: '8px',
      color: Theme.colors.greyDark,
      '& svg': {
        fontSize: '20px'
      },
    },
    transitionContainer: {
      color: Theme.colors.greyDark,
      '& p': {
        fontFamily: 'Bryant Pro Regular',
        fontSize: Theme.typography.bodyText,
        fontWeight: 'normal',
        letterSpacing: '0.0175em',
        whiteSpace: 'normal',
      }
    },
    dayLabel: {
      color: Theme.colors.greyMedium,
      fontFamily: 'Bryant Pro Regular',
      fontSize: Theme.typography.smallText,
      fontWeight: 'normal',
      letterSpacing: '0.0175em',
      whiteSpace: 'normal',
    },
  },
  MuiPickersDay: {
    day: {
      color: Theme.colors.greyDark,
      '& p': {
        fontFamily: 'Bryant Pro Regular',
        fontSize: Theme.typography.bodyText,
        fontWeight: 'normal',
        letterSpacing: '0.0175em',
        whiteSpace: 'normal',
      }
    },
    daySelected: {
      backgroundColor: Theme.colors.blueDark,
      '&:hover': {
        backgroundColor: Theme.colors.blueDark,
      }
    },
    current: {
      color: Theme.colors.blueDark,
    },
  },
  MuiPickersYear: {
    root: {
      color: Theme.colors.greyDark,
      fontFamily: 'Bryant Pro Regular',
      fontSize: Theme.typography.bodyText,
      fontWeight: 'normal',
      letterSpacing: '0.0175em',
      whiteSpace: 'normal',
    },
    yearSelected: {
      color: Theme.colors.blueDark,
      fontFamily: 'Bryant Pro Medium',
    }
  },
  MuiPickersMonth: {
    root: {
      color: Theme.colors.greyDark,
      fontFamily: 'Bryant Pro Regular',
      fontSize: Theme.typography.bodyText,
      fontWeight: 'normal',
      letterSpacing: '0.0175em',
      whiteSpace: 'normal',
    },
    monthSelected: {
      color: Theme.colors.blueDark,
      fontFamily: 'Bryant Pro Medium',
    }
  },
  MuiPickersClock: {
    pin: {
      backgroundColor: Theme.colors.blueDark
    },
  },
  MuiPickersClockPointer: {
    pointer: {
      backgroundColor: Theme.colors.blueDark
    },
    noPoint: {
      backgroundColor: Theme.colors.blueDark
    },
    thumb: {
      borderColor: Theme.colors.blueDark
    }
  },
  MuiPickersClockNumber: {
    clockNumber: {
      color: Theme.colors.greyDark,
      fontFamily: 'Bryant Pro Regular',
      fontSize: Theme.typography.bodyText,
      fontWeight: 'normal',
      letterSpacing: '0.0175em',
      whiteSpace: 'normal',
    },
  }
};

export class LocalizedUtils extends MomentUtils {
  getDatePickerHeaderText(date) {
    return moment(date).format('LL');
  }
}

export const getPickerLanguage = () => {
  try {
    const lsLanguage = JSON.parse(localStorage.getItem('ls.ty-Language'));
    return lsLanguage && lsLanguage.language ? lsLanguage.language : 'es';
  } catch (error) {
    return 'es';
  }
};

export const getPickerLocale = (lang) => localeMap[lang] || localeMap.es;

export const setPickerMomentLocale = (lang) => {
  moment.locale(getPickerLocale(lang));
};

export const createPickerTheme = (customOverrides = {}) => createTheme({
  overrides: {
    ...commonPickerOverrides,
    ...customOverrides
  }
});
